var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "title_h1" }, [_vm._v("緑地化計画一覧")]),
      _c(
        "vab-row",
        { staticClass: "row_box margin_bottom_16" },
        [
          _c(
            "vab-col",
            {
              staticClass: "title_box border_left border_bottom",
              attrs: { span: 4 },
            },
            [_vm._v(" 建物 ")]
          ),
          _c(
            "vab-col",
            {
              staticClass: "word_box border_bottom border_right",
              attrs: { span: 20 },
            },
            [
              _c("div", { staticClass: "flex_space flex_center_align" }, [
                _c("div", { staticClass: "flex_auto line_height" }, [
                  _vm._v("セントラルフィールド中目黒"),
                ]),
                _c("div", { staticClass: "sub_title" }, [
                  _vm._v("（建物CD：A0130）"),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            [
              _c("vab-table", {
                ref: "table",
                attrs: {
                  "api-url": "/api/greeningPlans/partner/pager",
                  columns: _vm.columns,
                  "custom-config": false,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }